import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  rubricDetails: {
    id: 'frontend-app-ora.InfoPopover.rubricDetails',
    defaultMessage: 'Rubric details',
    description: 'Rubric details info popover help text',
  },
  altText: {
    id: 'frontend-app-ora.InfoPopover.alt-text',
    defaultMessage: 'Display more info',
    description: 'Info popover trigger element alt-text',
  },
});

export default messages;
